import { __assign, __awaiter, __decorate, __generator, __metadata, __param } from "tslib";
import { INetworkRequestService } from '../../base/request/network-request.interface';
import { exitOrEmptyString } from '../../base/utils';
import { IDocMetaDomainService } from '../../doc-meta/service/doc-meta-domain-service.interface';
import { BROWSER_LIST, EXPORT_TO_PC, GET_RECENT_USER_INFO, SEND_DOC_TO_MEMBERS, } from './cgi-path';
import { COMMON_COOKIES_KEYS, getCookieByCommonKey } from '@tencent/ark-utils/lib/cookie';
import { addURLParameters } from '@tencent/ark-utils/lib/url';
var ShareRepository = /** @class */ (function () {
    function ShareRepository(docMetaDomainService, networkRequestService) {
        this.docMetaDomainService = docMetaDomainService;
        this.networkRequestService = networkRequestService;
    }
    ShareRepository.prototype.fetchRecentUserInfo = function () {
        return __awaiter(this, void 0, void 0, function () {
            var params, url;
            return __generator(this, function (_a) {
                params = {
                    padId: this.docMetaDomainService.docMetaEntity.padInfo.padId,
                    domain: this.docMetaDomainService.docMetaEntity.padInfo.domainId,
                    xsrf: "".concat(getCookieByCommonKey(COMMON_COOKIES_KEYS.xsrf)),
                };
                url = addURLParameters(GET_RECENT_USER_INFO, params);
                return [2 /*return*/, this.networkRequestService.instance.post(url)];
            });
        });
    };
    ShareRepository.prototype.sendDocToMember = function (memberList, corpId) {
        return __awaiter(this, void 0, void 0, function () {
            var params;
            return __generator(this, function (_a) {
                params = {
                    padId: this.docMetaDomainService.docMetaEntity.padInfo.padId,
                    domainId: this.docMetaDomainService.docMetaEntity.padInfo.domainId,
                    addmemlist: JSON.stringify(memberList),
                    corpid: exitOrEmptyString(corpId),
                    xsrf: getCookieByCommonKey(COMMON_COOKIES_KEYS.xsrf),
                };
                return [2 /*return*/, this.networkRequestService.instance.post(SEND_DOC_TO_MEMBERS, __assign({}, params))];
            });
        });
    };
    /**
     * 导出到PC
     */
    ShareRepository.prototype.exportToPC = function () {
        return __awaiter(this, void 0, void 0, function () {
            var params;
            return __generator(this, function (_a) {
                params = {
                    padId: this.docMetaDomainService.docMetaEntity.padInfo.padId,
                    xsrf: getCookieByCommonKey(COMMON_COOKIES_KEYS.xsrf),
                };
                return [2 /*return*/, this.networkRequestService.instance.post(EXPORT_TO_PC, __assign({}, params))];
            });
        });
    };
    /**
     * 获取已读列表
     */
    ShareRepository.prototype.fetchBrowserList = function (start, count) {
        return __awaiter(this, void 0, void 0, function () {
            var params, url;
            return __generator(this, function (_a) {
                params = {
                    domain_id: this.docMetaDomainService.docMetaEntity.padInfo.domainId,
                    pad_id: this.docMetaDomainService.docMetaEntity.padInfo.padId,
                    start: start,
                    limit: count,
                    xsrf: "".concat(getCookieByCommonKey(COMMON_COOKIES_KEYS.xsrf)),
                    t: new Date().getTime(), // 防止IE缓存，加时间戳
                };
                url = addURLParameters(BROWSER_LIST, params);
                return [2 /*return*/, this.networkRequestService.instance.get(url)];
            });
        });
    };
    ShareRepository = __decorate([
        __param(0, IDocMetaDomainService),
        __param(1, INetworkRequestService),
        __metadata("design:paramtypes", [Object, Object])
    ], ShareRepository);
    return ShareRepository;
}());
export default ShareRepository;
